import {
  type MeResposta,
  type MeVouchersResposta,
  type MeIndicacoesResposta,
  type PublicoConfiguracaoResposta,
  type PublicoIndicacaoResposta,
  type TipoEventoPortalCliente,
  meCodigoRespostaSchema,
  meIndicacoesRespostaSchema,
  meRespostaSchema,
  meVouchersRespostaSchema,
  publicoConfiguracaoRespostaSchema,
  publicoIndicacaoRespostaSchema,
} from '@varga/shared';
import { api, apiVoid } from '../../lib/http';

/**
 * Chamadas do portal do cliente (`/v1/me/*`) e das rotas públicas
 * (`/v1/publico/*`). O portal **só lê** (CLAUDE.md regra 1); o único POST é
 * `/me/evento`, contagem de engajamento sem PII (SPEC §8).
 */

export const buscarMe = (): Promise<MeResposta> => api(meRespostaSchema, '/v1/me');

export const buscarCodigo = (): Promise<{ codigo: string }> =>
  api(meCodigoRespostaSchema, '/v1/me/codigo');

export const buscarVouchers = (): Promise<MeVouchersResposta> =>
  api(meVouchersRespostaSchema, '/v1/me/vouchers');

export const buscarIndicacoes = (): Promise<MeIndicacoesResposta> =>
  api(meIndicacoesRespostaSchema, '/v1/me/indicacoes');

/** Contagem de engajamento — falha em silêncio (nunca bloqueia a UI). */
export async function registrarEvento(tipo: TipoEventoPortalCliente): Promise<void> {
  try {
    await apiVoid('/v1/me/evento', { method: 'POST', body: { tipo } });
  } catch {
    /* métrica de conveniência — não interrompe o cliente */
  }
}

export const buscarConfiguracaoPublica = (): Promise<PublicoConfiguracaoResposta> =>
  api(publicoConfiguracaoRespostaSchema, '/v1/publico/configuracao', { autenticada: false });

export const buscarIndicacaoPublica = (codigo: string): Promise<PublicoIndicacaoResposta> =>
  api(publicoIndicacaoRespostaSchema, `/v1/publico/indicacao/${encodeURIComponent(codigo)}`, {
    autenticada: false,
  });
